import ProviderSegmentationList from './components/ProviderSegmentationList';
import { bindActionCreators } from 'redux';
import withRouter from 'react-router-dom/withRouter'
import values from 'lodash/values';
import { connect } from 'react-redux';

import { loadSegments } from '../../shared/redux/entities/actions'

function mapStateToProps(state,props){
  return {
    segments:values(state.entities.segmentations)
  };
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    loadSegments
  },dispatch);
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(ProviderSegmentationList));



// WEBPACK FOOTER //
// ./src/routes/ProviderSegmentationList/index.js